var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Elements",
    transform: "translate(-771.000000, -516.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(771.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#1DDCC0",
    cx: 16,
    cy: 16,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(6.857143, 6.857143)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6297143,6.208 L7.70742857,10.1394286 L6.19885714,8.63085714 C5.97541497,8.3699418 5.62457747,8.25629079 5.29058837,8.33663073 C4.95659927,8.41697067 4.69582782,8.67774213 4.61548788,9.01173123 C4.53514794,9.34572032 4.64879894,9.69655782 4.90971429,9.92 L7.05828571,12.0777143 C7.23082865,12.2488562 7.4644087,12.3442622 7.70742857,12.3428571 C7.94728217,12.3418472 8.17713313,12.2466232 8.34742857,12.0777143 L12.9188571,7.50628571 C13.091943,7.33461339 13.1893013,7.10092575 13.1893013,6.85714286 C13.1893013,6.61335997 13.091943,6.37967232 12.9188571,6.208 C12.5622515,5.85350986 11.98632,5.85350986 11.6297143,6.208 Z M9.14285714,4.0602442e-16 C4.09339657,-2.0301221e-16 4.0602442e-16,4.09339657 0,9.14285714 C-4.0602442e-16,14.1923177 4.09339657,18.2857143 9.14285714,18.2857143 C14.1923177,18.2857143 18.2857143,14.1923177 18.2857143,9.14285714 C18.2857143,6.71802066 17.3224517,4.39249917 15.6078334,2.67788086 C13.8932151,0.96326254 11.5676936,2.0301221e-16 9.14285714,4.0602442e-16 Z M9.14285714,16.4571429 C5.10328869,16.4571429 1.82857143,13.1824256 1.82857143,9.14285714 C1.82857143,5.10328869 5.10328869,1.82857143 9.14285714,1.82857143 C13.1824256,1.82857143 16.4571429,5.10328869 16.4571429,9.14285714 C16.4571429,11.0827263 15.6865328,12.9431435 14.3148382,14.3148382 C12.9431435,15.6865328 11.0827263,16.4571429 9.14285714,16.4571429 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileReceived);
export default __webpack_public_path__ + "static/media/FileReceived.91cad71e6f145e6bc4c7bc80eef1622c.svg";
export { ForwardRef as ReactComponent };